import { DevicePrediction } from 'src/interfaces/DevicePrediction.interface';

const useMockData = false; // Đặt `true` để sử dụng mock data, `false` để gọi API thực tế

// Mock data
const mockPredictions: DevicePrediction = {
  "DEVICE_1746355562363": {
    predicted_time: '2025-06-03T18:04:00',
    predicted_ranges: 3,
  },
  "DEVICE_1718433046201": {
    predicted_time: '2025-01-01T17:20:00',
    predicted_ranges: 5,
  },
  "DEVICE_1718432930856": {
    predicted_time: '2025-01-01T17:35:00',
    predicted_ranges: 10,
  },
  // 38
  'DEVICE_1718433134296': {
    predicted_time: '2025-01-01T17:50:00',
    predicted_ranges: 15,
  },
};

// Hàm fetch dữ liệu từ API thực tế
const fetchFromAPI = async (param: any): Promise<DevicePrediction> => {
  try {
    // Chuyển đổi param từ dạng { key: { S: value } } sang { key: value }
    const convertParam = (input: any) => {
      if (!input || typeof input !== 'object') return input;
      const result: any = {};
      for (const key in input) {
        if (input[key] && typeof input[key] === 'object' && 'S' in input[key]) {
          result[key] = input[key]['S'];
        } else {
          result[key] = input[key];
        }
      }
      return result;
    };

    const requestParam = param ? convertParam(param) : {
      DEVICE_ID: "DEVICE_1717950746514",
      CREATE_AT: "2024-01-01 12:00:00",
      PUBLISH_FORMATED: "2024/01/01 12:00:00", // Thêm trường mới vào param mặc định
      CNT: 1,
      DEVICE_NUMBER: 100,
      DIS: 0.0,
      FLOW_RATE: 0.0,
      GID: 1,
      POS: "A",
      Publish: "2025-01-01 12:00:00",
      RF: 0,
      SID: 1,
      VELOCITY: 194.263,
      VOL: 0.0,
      WATER_LEVEL: 0.0
    };

    const deviceId = requestParam.DEVICE_ID || "DEVICE_1717950746514";

    console.log("[Prediction Service] Sending prediction request with params:", requestParam);

    const response = await fetch('https://prediction.watergraph.net/predict', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        param: requestParam,
        deviceId: deviceId
      }),
    });

    if (!response.ok) {
      console.error("[Prediction Service] API response not OK:", response.status, response.statusText);
      throw new Error(`[Prediction Service] Failed to fetch predictions from API: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log("[Prediction Service] API response:", data);
    return data.result as DevicePrediction;
  } catch (error) {
    console.error('[Prediction Service] Error fetching predictions:', error);
    throw error;
  }
};

// Hàm fetch dữ liệu (dynamic)
export const fetchPredictions = async (param: any): Promise<DevicePrediction> => {
  if (useMockData) {
    console.log('[Prediction Service] Using mock data for predictions');
    return mockPredictions;
  }

  try {
    console.log('[Prediction Service] Fetching predictions from API');
    return await fetchFromAPI(param);
  } catch (error) {
    console.error('[Prediction Service] API call failed, falling back to mock data:', error);
    return mockPredictions;  // Fallback to mock data on error
  }
};
